import { render, staticRenderFns } from "./MainCom.vue?vue&type=template&id=9650b9c2&scoped=true"
import script from "./MainCom.vue?vue&type=script&lang=js"
export * from "./MainCom.vue?vue&type=script&lang=js"
import style0 from "./MainCom.vue?vue&type=style&index=0&id=9650b9c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9650b9c2",
  null
  
)

export default component.exports